// File: /src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/base.css'; // Global CSS reset (imported first)
import './index.css'; // Theme variables and global styles
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
